// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-lists-setup .rai-setup-content:not(.rai-setup-content--loading)>.v-expansion-panel-content__wrap{padding:0 0 16px 0}", ""]);
// Exports
module.exports = exports;
